import {
  convertQrLoginAccessDetails,
  QRLoginAccessDetails,
} from '@nextforce/api'
import { t } from 'app/i18l'
import { BarCodeScanningResult, Camera, PermissionResponse } from 'expo-camera'
import { ScanQRCodeScreenProps } from 'home/stack/types'
import { isEqual } from 'lodash'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { Alert } from 'react-native'
import { useScanWebQR } from './queries/scan_web_qr'
import { ScanQRCodeView } from './view'

export function ScanQrCodeScreen({ navigation, route }: ScanQRCodeScreenProps) {
  const [scanResult, setScanResult] = useState<QRLoginAccessDetails>()
  const scanWebQRMutation = useScanWebQR()
  const [permission, setPermission] = useState<PermissionResponse | null>(null)

  const onQRCodeScanned = useCallback(
    async (result: BarCodeScanningResult) => {
      if (!isEqual(result.data, scanResult)) {
        setScanResult(result.data)
        await scanWebQRMutation.mutateAsync(
          convertQrLoginAccessDetails(JSON.parse(result.data))
        )
      }
      navigation.goBack()
    },
    [scanResult, navigation, scanWebQRMutation]
  )

  const checkAndRequestPermission = async () => {
    const currentPermission = await Camera.getCameraPermissionsAsync()
    if (currentPermission.status !== 'granted') {
      const newPermission = await Camera.requestCameraPermissionsAsync()
      setPermission(newPermission)
      if (newPermission.status !== 'granted') {
        Alert.alert(
          t('cameraPermissionDeniedTitle'),
          t('cameraPermissionDeniedBody')
        )
      }
    } else {
      setPermission(currentPermission)
    }
  }

  useLayoutEffect(() => {
    checkAndRequestPermission().catch(() => null)
  }, [])

  return (
    <ScanQRCodeView onQRCodeScanned={onQRCodeScanned} permission={permission} />
  )
}
